import React, {useEffect, useState} from "react";
import '../../../../styles/component/asset/asset-overdue.scss'
import server from "../../../../server";
import Grid from "../../../../common/table";
import EmployeeAvatar from "../../../employee/avatar/employee-avatar";
import EmployeeOverviewPopover from "../../../employee/overview/employee-overview-popover/employee-overview-popover";
import {getName, removeUnderScore} from "../../../../utility/utility";
import dayjs from "dayjs";
import Locale from "../../../../core/locale/locale";
import {Form, message, Tag, Tooltip} from "antd";
import OverdueModal from "./utils/overdue-modal";
import {RotateCcw} from "lucide-react";
import LoadingSkeleton from "../../../common/loading-skeleton/loading-skeleton";

const OverdueAssets = () => {
    const [state, setState] = useState({
        overdueData: [],
        modal: false,
        selectedRecord: ""
    })
    const [assetOverdueForm] = Form.useForm();
    const [pageNumber, setPageNumber] = useState(0);
    const pageSize = 10;
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchOverdueAssets()
    }, []);

    const handleNextPage = () => {
        setPageNumber(prev => prev + 1);
    };

    const handlePrevPage = () => {
        if (pageNumber > 0) {
            setPageNumber(prev => prev - 1);
        }
    };

    async function fetchOverdueAssets() {
        setLoading(true);
        try {
            const payload = {
                overdueAssets: true
            }
            const overdueAssetsData = await server.asset.allocation.search(pageNumber, pageSize, payload);
            setState((prev) => ({
                ...prev,
                overdueData: overdueAssetsData
            }))
        } catch (e) {
            console.log("Error while fetching assets", e);
        } finally {
            setLoading(false);
        }
    }

    const handleRenew = (record: any) => {
        setState((prev) => ({
            ...prev,
            modal: true,
            selectedRecord: record.asset.id
        }))
    }

    const handleRenewModalClose = () => {
        setState((prev) => ({
            ...prev,
            modal: false
        }))
    }

    async function handleRenewSubmit() {
        try {
            const formValues = await assetOverdueForm.validateFields();
            const updatedExpectedReturnDate = formValues.updatedExpectedReturnDate.format(Locale.dateFormat)
            await server.asset.renewal(state.selectedRecord, updatedExpectedReturnDate);
            message.success("Successfully updated expected return date!")
            await fetchOverdueAssets();
            handleRenewModalClose();
        } catch (e) {
            console.log("Error while updating renewal date")
        }
    }

    const columns = [
        {
            title: "Employee Name",
            dataIndex: "employeeProfile",
            key: "employeeProfile",
            render: (_: any, record: any) => {
                console.log("record", record)
                return (
                    <div className="employee-name-wrapper">
                        <EmployeeAvatar
                            name={{
                                firstName: record?.employeeProfile?.name?.firstName,
                                lastName: record?.employeeProfile?.name?.lastName
                            }}
                            thumbnailId={record?.employeeProfile?.profileThumbnailId}
                            size={25}
                        />
                        <EmployeeOverviewPopover
                            employeeId={record.employeeProfile.id}
                            uniqueKey={`${record?.employeeProfile.id}-${record.id}`}
                        >
                            <div className="employee-search-table-name">
                                {getName(record.employeeProfile.name.firstName, record.employeeProfile.name.middleName, record.employeeProfile.name.lastName)}
                            </div>
                        </EmployeeOverviewPopover>
                    </div>
                );
            }
        },
        {
            title: "Category Name",
            dataIndex: "categoryName",
            key: "categoryName",
            render: (_: any, record: any) => {
                return (
                    record?.assetCategory?.name ? record?.assetCategory?.name : "-"
                )
            }
        },
        {
            title: "Brand Name",
            dataIndex: "brandName",
            key: "brandName",
            render: (_: any, record: any) => {
                return record?.asset?.brandName ? record.asset.brandName : "-"
            }
        },
        {
            title: "Asset Code",
            dataIndex: "assetCode",
            key: "assetCode",
            render: (_: any, record: any) => {
                return record?.asset?.assetCode ? record?.asset?.assetCode : "-"
            }
        },
        {
            title: "Assigned Date",
            dataIndex: "assignedDate",
            key: "assignedDate",
            render: (_: any, record: any) => {
                return record?.assignedDate ? dayjs(record?.assignedDate).format(Locale.displayDate) : "-"
            }

        },
        {
            title: "Expected Return Date",
            dataIndex: "expectedReturnDate",
            key: "expectedReturnDate",
            render: (_: any, record: any) => {
                return record?.expectedReturnDate ? dayjs(record?.expectedReturnDate).format(Locale.displayDate) : "-"
            }
        },
        {
            title: "Status",
            dataIndex: "status",
            key: "status",
            render: (_: any, record: any) => {
                return <Tag className={`asset-allocation-status ${record.status.toLowerCase()}`}>
                    {record?.status ? removeUnderScore(record.status) : "-"}
                </Tag>

            }
        },
        {
            title: "Actions",
            dataIndex: "actions",
            key: "actions",
            render: (_: any, record: any) => {
                return (
                    <div className={'pn-table-actions'}>
                        <Tooltip title={"Renew Asset"}>
                            <RotateCcw className={'action-renew'} onClick={() => handleRenew(record)}/>
                        </Tooltip>
                    </div>)
            }
        }
    ]

    return (
        <div className={'overdue-assets'}>
            <h1 className={'overdue-assets heading'}>Overdue Assets </h1>
            <div className={'asset-overdue-table'}>
                <LoadingSkeleton loading={loading}>
                    <Grid
                        bordered={true}
                        dataSource={state.overdueData}
                        columns={columns}
                        pageNumber={pageNumber}
                        paginationButton={true}
                        pageSize={pageSize}
                        handleNextPage={handleNextPage}
                        handlePrevPage={handlePrevPage}
                    />
                </LoadingSkeleton>
            </div>

            <OverdueModal
                open={state.modal}
                assetOverdueForm={assetOverdueForm}
                handleRenewSubmit={handleRenewSubmit}
                handleRenewModalClose={handleRenewModalClose}
            />


        </div>
    )
}
export default OverdueAssets;
